import respond from './utilities/respond'
import at from '../../actionTypes'
import verifyUserLocalStorage from '../../../dataservices/verifyUserLocalStorage'

const userProfileActions = {
	verifyUserSetToLocalstorage: dispatch => (verifyUserObject) => {
		verifyUserLocalStorage.setVerifyUserObject(verifyUserObject)
		dispatch(userProfileActions.verifyUserSet(verifyUserObject))
	},
	verifyUserRemoveFromLocalstorage: dispatch => () => {
		verifyUserLocalStorage.removeVerifyUserObject()
		dispatch(userProfileActions.verifyUserReset())
	},
	verifyUserSet: verifyUserObject => respond(at.VERIFYUSER_SET, { verifyUserObject }),
	verifyUserReset: () => respond(at.VERIFYUSER_RESET),
	verifyUserSuccess: verifiedUserObject => respond(at.VERIFYUSER_SUCCESS, { verifiedUserObject }),
	verifyUserFail: verifiedUserObject => respond(at.VERIFYUSER_FAIL, { verifiedUserObject })

}

export default userProfileActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/userProfileActions.js